import { envDefaultsToDarkmode, envThemes } from '@/utils/env';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: envThemes,
    dark: envDefaultsToDarkmode,
  },
});
